import React, { useEffect } from "react";
import { Sparkles, Users, Rocket, Heart, Trophy, ShieldCheck } from "lucide-react";

const values = [
  { icon: Heart, title: "Affordable First", desc: "Quality education can't be a luxury. That's why our prices start at just ₹99." },
  { icon: Trophy, title: "Result-Driven", desc: "Every course is designed with one goal — getting our students hired or selected." },
  { icon: ShieldCheck, title: "Trust & Transparency", desc: "Verified content, honest pricing, and real placement stories — no gimmicks." },
];

export default function AboutPage() {
  useEffect(() => {
    document.title = "About Aducation — Since 2022 | India's Most Loved Ed-Tech Startup";
  }, []);

  return (
    <div data-testid="about-page">
      <section className="relative overflow-hidden">
        <div className="hero-glow absolute inset-0 pointer-events-none" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-14 pb-16 relative">
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-2 gold-pill px-4 py-1.5 rounded-full text-xs font-semibold uppercase tracking-widest mb-6">
              <Sparkles size={14} /> Since 2022
            </div>
            <h1 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[1.05]">
              Democratizing <span className="red-text">World-Class</span> Education for <span className="gold-text">Every Indian</span>.
            </h1>
            <p className="mt-6 text-lg text-slate-300 leading-relaxed">
              Aducation started in 2022 as a small startup with a big dream — to make top-quality learning accessible to every student in Bharat, no matter their background or budget.
            </p>
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16">
        <div className="grid md:grid-cols-2 gap-10 items-center">
          <div>
            <div className="text-xs uppercase tracking-[0.3em] text-amber-400 font-semibold mb-3">Our Story</div>
            <h2 className="font-display font-bold text-3xl lg:text-4xl mb-5">
              From a <span className="gold-text">Small Idea</span> to India's Fastest Growing Learning App
            </h2>
            <div className="space-y-4 text-slate-300 leading-relaxed">
              <p>
                In 2022, a group of educators, engineers, and dreamers came together with a shared frustration — quality courses in India were either overpriced or of poor quality. Coaching institutes were charging ₹50,000+ for exam prep. Skill bootcamps costed a fortune.
              </p>
              <p>
                We asked ourselves: <span className="text-amber-300 italic">"What if every serious learner in India could get the best mentors at the price of a movie ticket?"</span>
              </p>
              <p>
                That's how <span className="text-white font-semibold">Aducation</span> was born. Today, we're proud to host courses from India's most loved teachers, mentors, and content creators — spanning Government Job preparation, Skills, and Personal Development.
              </p>
              <p className="text-emerald-300 font-semibold">
                17,000+ students. 10M+ YouTube views. 100K+ hours of watch time. And we're just getting started.
              </p>
            </div>
          </div>
          <div className="relative">
            <div className="glass rounded-3xl p-8 lg:p-10">
              <Rocket className="text-amber-400 mb-5" size={40} />
              <h3 className="font-display font-bold text-2xl mb-3">Our Mission</h3>
              <p className="text-slate-400 leading-relaxed">
                To be India's #1 destination for affordable, outcome-driven education — empowering 10 million learners by 2030.
              </p>
              <div className="mt-8 pt-8 border-t border-white/10">
                <Users className="text-red-400 mb-5" size={40} />
                <h3 className="font-display font-bold text-2xl mb-3">Our Vision</h3>
                <p className="text-slate-400 leading-relaxed">
                  A Bharat where every dream — whether it's cracking SSC CGL or landing at Google — is within reach of every serious student.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16">
        <div className="text-center mb-12">
          <div className="text-xs uppercase tracking-[0.3em] text-amber-400 font-semibold mb-3">Core Values</div>
          <h2 className="font-display font-bold text-3xl lg:text-4xl">What We Stand For</h2>
        </div>
        <div className="grid md:grid-cols-3 gap-5">
          {values.map((v, i) => {
            const Icon = v.icon;
            return (
              <div key={i} className="glass rounded-2xl p-8 hover:border-amber-400/40 transition">
                <Icon size={30} className="text-amber-400 mb-4" />
                <h3 className="font-display font-bold text-xl text-white mb-2">{v.title}</h3>
                <p className="text-slate-400 text-sm leading-relaxed">{v.desc}</p>
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
}
